// src/api.js
export async function generateQuestion(subject, askedQuestions = []) {
  try {
    console.log(`[${new Date().toISOString()}] Sending request to Netlify function`); // Log before sending request
    const userApiKey = typeof localStorage !== 'undefined' ? (localStorage.getItem('openai_api_key') || null) : null;
    const isBrowser = typeof window !== 'undefined';
    const isDev = process.env.NODE_ENV === 'development';
    const defaultDevBase = 'http://localhost:8888';
    const configuredBase = process.env.REACT_APP_NETLIFY_FUNCTIONS_URL || '';
    const baseUrl = isDev
      ? (configuredBase || (isBrowser && window.location.port === '8888' ? '' : defaultDevBase))
      : '';

    const response = await fetch(`${baseUrl}/.netlify/functions/generateQuestion`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ subject, askedQuestions, userApiKey }),
    });
    if (!response.ok) {
      throw new Error("Failed to fetch question");
    }
    const questionData = await response.json();
    if (!questionData.search) {
      questionData.search = subject; // Fallback to subject if search field is missing
    }
    return questionData;
  } catch (error) {
    console.error("Error fetching question:", error);
    return null;
  }
}